import type { TOC } from '@ember/component/template-only';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsMyotbBenchmarkSummary from 'lumen/components/settings/myotb/benchmark-summary';
import type HotelSettingsMyotbBenchmarkController from 'lumen/controllers/hotel/settings/myotb/benchmark';

interface HotelSettingsMyotbBenchmarkSignature {
  Args: {
    controller: HotelSettingsMyotbBenchmarkController;
    model: unknown;
  };
}

<template>
  <div {{didInsert @controller.setDefaults}}>
    <SettingsMyotbBenchmarkSummary
      @isInterestedInBenchmark={{@controller.isInterestedInBenchmark}}
      @toggleBenchmarkInterest={{@controller.toggleBenchmarkInterest}}
    >
      <div class="flex justify-between gap-300">
        <PrismButton
          @buttonType="ghost"
          @iconBefore="arrow-left"
          @label={{t "general.back"}}
          @onClick={{@controller.onClickPrevious}}
        />
        <PrismButton
          @iconAfter="arrow-right"
          @isLoading={{@controller.isLoading}}
          @label={{t "general.continue"}}
          @onClick={{@controller.onClickNext}}
        />
      </div>
    </SettingsMyotbBenchmarkSummary>
  </div>
</template> satisfies TOC<HotelSettingsMyotbBenchmarkSignature>;
